<template lang="pug">
  div
    AlertMessage
    ConcatMessage
    Navbar
    router-view
    Footer
</template>

<script>
import AlertMessage from '@/components/pages/AlertMessage';
import ConcatMessage from '@/components/pages/ConcatMessage';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default {
  data() {
    return {
    };
  },
  components: {
    Navbar,
    Footer,
    AlertMessage,
    ConcatMessage,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Layout.vue